import {
  Alert,
  AlertDescription,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import { TriangleAlertIcon } from 'lucide-react';

export type RemoveSsoDomainModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  domain: string;
  /** Removing it leaves the connection without a verified domain, so it stops letting people in. */
  isLastVerifiedOfActiveConnection: boolean;
  isRemoving?: boolean;
  onConfirm: () => void;
};

export const RemoveSsoDomainModal = ({
  open,
  onOpenChange,
  domain,
  isLastVerifiedOfActiveConnection,
  isRemoving,
  onConfirm,
}: RemoveSsoDomainModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Remove {domain}?</DialogTitle>
        <DialogDescription>
          Addresses on this domain stop signing in through your identity
          provider. You can claim it again later, with a new DNS record to
          publish.
        </DialogDescription>
      </DialogHeader>

      {isLastVerifiedOfActiveConnection && (
        <Alert variant="important">
          <TriangleAlertIcon />
          <AlertDescription>
            This is the last verified domain of an active connection: removing
            it switches single sign-on off and lifts the requirement. Everyone
            signs in with their password again.
          </AlertDescription>
        </Alert>
      )}

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          isLoading={isRemoving}
        >
          Remove domain
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
